import { inject, type InjectionKey } from 'vue'

import type { OperacoesCatalogoEmpregado } from '../catalogo-empregado.tipos'

export const CHAVE_OPERACOES_CATALOGO_EMPREGADO:
InjectionKey<OperacoesCatalogoEmpregado> = Symbol(
  'operacoes-catalogo-empregado',
)

export const usarOperacoesCatalogoEmpregado = (
): OperacoesCatalogoEmpregado => {
  const operacoes = inject(CHAVE_OPERACOES_CATALOGO_EMPREGADO)
  if (!operacoes) {
    throw new Error('Catalogo de empregado nao foi instalado')
  }
  return operacoes
}
